import Axios from 'axios';
import { readMeta } from './page';
import { readDomainCookie } from './domain_cookie';

export interface DeviceSession {
  device_label: string;
  active: boolean;
  created_at: string | null;
  last_seen_at: string | null;
  last_ip_address: string | null;
}

export interface DeviceSessionsResponse {
  device_sessions: DeviceSession[];
  total_records: number;
}

export async function fetchDeviceSessions(): Promise<DeviceSessionsResponse | null> {
  const refreshToken = readDomainCookie('refresh');
  const ssoUrl = readMeta('sso_url');

  if (!refreshToken || !ssoUrl) {
    return null;
  }

  try {
    const response = await Axios.post<DeviceSessionsResponse>(
      '/device-sessions',
      {
        refresh_token: refreshToken,
        include_inactive: true,
        limit: 50,
      },
      {
        baseURL: ssoUrl,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Failed to load device sessions', error);
    return null;
  }
}

export function deviceSessionStatus(session: DeviceSession): string {
  return session.active ? 'Active' : 'Signed out';
}
